"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerError = void 0;
var tslib_1 = require("tslib");
var typedefs_1 = require("./typedefs");
var DealerError = /** @class */ (function (_super) {
    tslib_1.__extends(DealerError, _super);
    /**
     * Represents a dealer error.
     *
     * @param code - The error code.
     * @param message - The error message.
     * @param event - Remote event from dealer.
     */
    function DealerError(code, message, event) {
        if (code === void 0) { code = typedefs_1.DealerErrors.DEALER_ERROR; }
        if (event === void 0) { event = {}; }
        var _this = _super.call(this, message) || this;
        _this.name = 'DealerError';
        _this.message = message;
        _this.code = code;
        _this.raw = event;
        _this.wsCode = event.code || null;
        _this.wsReason = event.reason || null;
        return _this;
    }
    return DealerError;
}(Error));
exports.DealerError = DealerError;
//# sourceMappingURL=error.js.map